export const CustomerIcon = () => {
  return (
    <span className="icon">
      <svg
        width="19"
        height="19"
        viewBox="0 0 19 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_2716_8646)">
          <path
            d="M9.36443 9.15235C10.6218 9.15235 11.7106 8.70139 12.6002 7.81164C13.4898 6.92203 13.9408 5.83354 13.9408 4.57603C13.9408 3.31896 13.4898 2.23032 12.6 1.34043C11.7103 0.450964 10.6217 0 9.36443 0C8.10691 0 7.01842 0.450964 6.12881 1.34057C5.2392 2.23018 4.78809 3.31881 4.78809 4.57603C4.78809 5.83354 5.2392 6.92218 6.12895 7.81178C7.01871 8.70124 8.10735 9.15235 9.36443 9.15235Z"
            fill="#B1B1B1"
          />
          <path
            d="M17.372 14.61C17.3463 14.2398 17.2944 13.836 17.218 13.4095C17.1409 12.9798 17.0416 12.5737 16.9227 12.2024C16.8 11.8187 16.633 11.4398 16.4266 11.0767C16.2123 10.6998 15.9607 10.3716 15.6783 10.1016C15.383 9.81903 15.0215 9.59188 14.6034 9.42619C14.1868 9.26138 13.7251 9.17788 13.2312 9.17788C13.0373 9.17788 12.8497 9.25746 12.4874 9.49331C12.2645 9.6387 12.0037 9.80685 11.7126 9.99283C11.4638 10.1514 11.1266 10.3 10.7101 10.4345C10.3038 10.566 9.89124 10.6327 9.48405 10.6327C9.07687 10.6327 8.66446 10.566 8.25771 10.4345C7.84167 10.3001 7.5045 10.1516 7.2559 9.99298C6.96758 9.80874 6.70665 9.64058 6.48037 9.49316C6.11855 9.25732 5.93083 9.17773 5.73688 9.17773C5.24286 9.17773 4.78131 9.26138 4.36485 9.42634C3.94707 9.59173 3.5854 9.81888 3.28983 10.1017C3.0076 10.3719 2.75581 10.6999 2.54185 11.0767C2.33557 11.4398 2.16858 11.8186 2.04565 12.2026C1.92693 12.5738 1.82764 12.9798 1.75052 13.4095C1.67413 13.8354 1.62223 14.2394 1.59657 14.6105C1.57135 14.974 1.55859 15.3513 1.55859 15.7324C1.55859 16.7242 1.87388 17.5272 2.49561 18.1193C3.10965 18.7036 3.92214 19.0001 4.91018 19.0001H14.0588C15.0468 19.0001 15.859 18.7038 16.4732 18.1193C17.0951 17.5276 17.4104 16.7245 17.4104 15.7323C17.4102 15.3495 17.3973 14.9718 17.372 14.61Z"
            fill="#B1B1B1"
          />
        </g>
        <defs>
          <clipPath id="clip0_2716_8646">
            <rect width="19" height="19" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </span>
  );
};
